export const PDPC_DATA_PROTECTION_OBLIGATIONS_URL = 'https://www.pdpc.gov.sg/overview-of-pdpa/the-legislation/personal-data-protection-act/data-protection-obligations'

const DRAFT_VERSION = 2
const DRAFT_MAX_AGE_MS = 12 * 60 * 60 * 1000

export function buildPrivacySafeReviewState(reviewState) {
    return Object.fromEntries(
        Object.entries(reviewState || {}).map(([itemId, itemState]) => [
            itemId,
            {
                ...(itemState?.finalStatus ? { finalStatus: itemState.finalStatus } : {}),
                ...(itemState?.resolution ? { resolution: itemState.resolution } : {})
            }
        ])
    )
}

export function persistReviewDraft(reviewId, reviewState, browserWindow = typeof window !== 'undefined' ? window : null) {
    if (!reviewId || !browserWindow) return

    try {
        removeLegacyDraft(reviewId, browserWindow)
        browserWindow.sessionStorage.setItem(reviewDraftKey(reviewId), JSON.stringify({
            version: DRAFT_VERSION,
            updatedAt: new Date().toISOString(),
            reviewState: buildPrivacySafeReviewState(reviewState)
        }))
    } catch (error) {
        // Server autosave remains authoritative when session storage is unavailable.
    }
}

export function readReviewDraft(reviewId, serverUpdatedAt, browserWindow = typeof window !== 'undefined' ? window : null) {
    if (!reviewId || !browserWindow) return null

    try {
        removeLegacyDraft(reviewId, browserWindow)
        const parsed = JSON.parse(browserWindow.sessionStorage.getItem(reviewDraftKey(reviewId)) || 'null')
        if (!parsed?.reviewState || parsed.version !== DRAFT_VERSION) return null

        const draftTime = new Date(parsed.updatedAt).getTime()
        const serverTime = new Date(serverUpdatedAt || 0).getTime()
        if (!Number.isFinite(draftTime) || Date.now() - draftTime > DRAFT_MAX_AGE_MS || draftTime <= serverTime) {
            clearReviewDraft(reviewId, browserWindow)
            return null
        }

        return parsed
    } catch (error) {
        clearReviewDraft(reviewId, browserWindow)
        return null
    }
}

export function clearReviewDraft(reviewId, browserWindow = typeof window !== 'undefined' ? window : null) {
    if (!reviewId || !browserWindow) return

    try {
        browserWindow.sessionStorage.removeItem(reviewDraftKey(reviewId))
        removeLegacyDraft(reviewId, browserWindow)
    } catch (error) {
        // Nothing else is required when browser storage is unavailable.
    }
}

export function reviewDraftKey(reviewId) {
    return `quality-review-draft:${reviewId}`
}

function removeLegacyDraft(reviewId, browserWindow) {
    try {
        browserWindow.localStorage.removeItem(reviewDraftKey(reviewId))
    } catch (error) {
        // Legacy storage may be unavailable or disabled.
    }
}
